interface Category {
  [key: string]: string;
}

interface Type extends Category {}

interface EventType {
  CLICK: Category;
  IMPRESSION: Category;
  ENTRY: Category;
  ACTION: Category;
}

export const CATEGORY: Category = {
  AF01: 'loan',
  AF02: 'card',
  AF03: 'insurance',
  AF05: 'deposit',
};

export const CATEGORY_NAME: Category = {
  LOAN: '대출',
  CARD: '카드',
  INSURANCE: '보험',
  DEPOSIT: '예적금',
  COLLECTION: '모아보기',
  '': '모아보기',
};

export const TYPE: Type = {
  C: 'outlink',
  P: 'promotion',
  T: 'template',
  I: 'inapp',
  D: 'da',
};
export const EVENT_TYPE: EventType = {
  CLICK: {
    DEFAULT: 'C001', // 클릭
    CATEGORY: 'C010', // 카테고리 클릭
  },
  /**
   * url접근 시 딱 한 번만 호출되는 부분, 예를들어 domain/skt/loan 으로 들어오면 I007 코드로 로그 한 번만 찍음.
   * 페이지 이동해도 그 다음부터는 찍지 않음.
   */
  IMPRESSION: {
    DEFAULT: 'I001', // 노출
    PROMOTION: 'I002', // 프로모션, 템플릿 노출 - 공통으로 사용한다고함
    HOME_MAIN: 'I017', // 홈 메인 노출
    LOAN_MAIN: 'I007', // 대출 메인 노출
    CARD_MAIN: 'I010', // 카드 메인 노출
    INSURANCE_MAIN: 'I013', // 보험 메인 노출
    DEPOSIT_MAIN: 'I015', // 예적금 메인 노출
    LOAN_PROMOTION: 'I008', // 대출 프로모션 노출
    CARD_PROMOTION: 'I011', // 카드 프로모션 노출
    DEPOSIT_PROMOTION: 'I016', // 예적금 프로모션 노출
    LOAN_TEMPLATE: 'I008', // 대출 프로모션 노출
    CARD_TEMPLATE: 'I011', // 카드 프로모션 노출
    INSURANCE_TEMPLATE: 'I014', // 보험 템플릿 인입
  },
  ENTRY: {
    COLLECTION: 'E005', // 진입
    LOAN: 'E001', // 대출 진입
    CARD: 'E002', // 카드 진입
    INSURANCE: 'E003', // 보험 진입
    DEPOSIT: 'E004', // 예적금 진입
    SAVING: 'E004', // 예적금 진입
  },
  ACTION: {
    CARD_APPLICATION: 'A001', // 카드 신청 (자세히보기)
    CARD_ENTRY: 'A002', // 카드 응모
    CARD_OUT_LINK: 'A011', // 카드 외부링크
    LOAN_APPLICATION: 'A004', //대출 신청 (내 한도 확인)
    DEPOSIT_ENTRY: 'A012', // 금리 자세히보기
    DEPOSIT_OUT_LINK: 'A013', // 예적금 외부링크
  },
};

export const ORDER_TYPE = {
  DEFAULT: 'H',
};

export const TELECOM: string[] = ['skt', 'kt', 'lgu'];

export const MEDIA_SEQ: { [key: string]: number } = {
  SKT: 1,
  LGU: 2,
  KT: 4,
  SAMSUNG_PAY: 5,
  L_POINT: 6,
};

export const COMPONENT_TYPE = {
  HEADER: 'header',
  BOARD: 'board',
  ROLLING: 'rolling',
  CATEGORY: 'category',
  FILTER: 'filter',
  LOAN: 'loan',
  CARD: 'card',
  CARD_TOP: 'cardTop',
  INSURANCE: 'insurance',
  SAVING: 'saving',
  DEPOSIT: 'deposit',
  TOP_SUPPORT: 'topSupport',
  BANNER: 'banner',
};

export const ORGANIC_TRACK_CD_TYPE: Category = {
  SKT: 'A009GA02',
  KT: 'D009GA02',
  LGU: 'B009GA02',
};

export const NAVLIST: Array<any> = [
  {
    name: 'loan',
    title: '오늘의 최저 금리 확인!',
  },
  {
    name: 'card',
    title: '최대 혜택&지원금 확인!',
  },
  {
    name: 'insurance',
    title: '나에게 정말 필요한 보험은?',
  },
  {
    name: 'deposit',
    title: '여유자금 불리기!',
  },
];

export const PLACEHOLDER_TOP_BANNER = '/placeholder-top-banner.png';
export const PLACEHOLDER_MIDDLE_BANNER = '/placeholder-middle-banner.png';
export const PLACEHOLDER_AVATAR_RECTANGLE = '/placeholder-avatar-rectangle.png';
export const PLACEHOLDER_AVATAR_CIRCLE = '/placeholder-avatar-circle.png';

interface IFooterInfo {
  logo: string;
  companyName: string;
  ceo: string;
  address: string;
  cs: string;
  companyIntroduction: string;
  privacyPolicy: string;
  companyRegistrationNumber: string;
  copyright: string;
  iosAppDownloadLink: string;
  androidAppDownloadLink: string;
}

export const FOOTER_INFO: { [key: string]: IFooterInfo } = {
  SKT: {
    logo: '/logo_skt.svg',
    companyName: 'SK텔레콤㈜',
    ceo: '대표이사 사장 유영상',
    address: '(04539) 서울특별시 중구 을지로 65(을지로2가) SK T-타워',
    cs: 'pass@sk.com',
    copyright: 'COPYRIGHT ©SK TELECOM CO., LTD.ALL RIGHTS RESERVED.',
    companyIntroduction: 'https://www.sktelecom.com/',
    privacyPolicy: 'https://www.sktelecom.com/view/footer/privacy.do',
    companyRegistrationNumber: '104-81-37225',
    iosAppDownloadLink: 'https://apps.apple.com/kr/app/pass-by-skt/id1141258007',
    androidAppDownloadLink:
      'https://play.google.com/store/apps/details?id=com.sktelecom.tauth&hl=ko',
  },
  KT: {
    logo: '/logo_ot.svg',
    companyName: '오버테이크㈜',
    ceo: '대표이사 이준정',
    address: '서울특별시 영등포구 당산로41길 11, 6층 E605호 (당산동4가)',
    cs: 'passad@overtake.kr',
    copyright: '© 2023 OVERTAKE Co., Ltd. All Rights Reserved.',
    companyIntroduction: 'https://overtake.kr/company/',
    privacyPolicy: 'https://overtake.kr/policy/privacy/',
    companyRegistrationNumber: '232-86-02064',
    iosAppDownloadLink: 'https://apps.apple.com/kr/app/pass-by-kt/id1134371550',
    androidAppDownloadLink:
      'https://play.google.com/store/apps/details?id=com.kt.ktauth&hl=ko&gl=US',
  },
  LGU: {
    logo: '/logo_lgu.svg',
    companyName: '㈜엘지유플러스',
    ceo: '대표이사 황현식',
    address: '서울특별시 용산구 한강대로 32',
    cs: 'mfinance@lguplus.co.kr',
    companyIntroduction: 'https://www.lguplus.com/',
    privacyPolicy: 'http://p-policy.uplus.co.kr/privacy/info/v1',
    companyRegistrationNumber: '220-81-39938',
    iosAppDownloadLink: 'https://apps.apple.com/kr/app/pass-by-u/id1147394645',
    androidAppDownloadLink:
      'https://play.google.com/store/apps/details?id=com.lguplus.smartotp&hl=ko&gl=US',
    copyright: 'Copyright ⓒ LG Uplus Corp. All Rights Reserved.',
  },
};
